<!-- <div class="flex flex-row">
<mat-toolbar>
  <div class="flex">
    <h2 class="px-2 text-2xl md:text-2xl font-extrabold tracking-tight leading-10 truncate">
      {{customerHeaderService.title()}}
    </h2>

    <button *ngIf="customerHeaderService.showRouterLink()" mat-mini-fab color="primary" class="mx-5"
      (click)="navigate()"><mat-icon>add</mat-icon>
    </button> -->
<!-- <button *ngIf="customerHeaderService.showRouterLink()" mat-mini-fab color="primary" class="mx-5"
    [routerLink]="customerHeaderService.newEntityRouterLink()"><mat-icon>add</mat-icon>
  </button> -->
<!-- <button *ngIf="customerHeaderService.showRouterLink()" mat-mini-fab color="primary" class="mx-5"
  (click)="navigate()"><mat-icon>add</mat-icon> </button> -->
<!-- </div>
<div class="flex text-lg px-2 mx-1 font-extrabold tracking-wide leading-10 bg-primary uppercase text-white truncate rounded"
  *ngIf="customerHeaderService.badge()">
  {{customerHeaderService.badge()}}
</div>
</mat-toolbar>

</div> -->

<mat-toolbar class="p-0 w-full bg-card gap-2">
  <h2 class="lg:text-2xl text-xl font-extrabold tracking-tight text-base/8 truncate min-w-0 flex-shrink">
    {{customerHeaderService.title()}}
    @if(customerHeaderService.showEntityDataMetadataReadonly().createdDate) {
    <small>
      <span>Created on </span>
      <span class="text-primary">{{customerHeaderService.showEntityDataMetadataReadonly().createdDate | date :
        'mediumDate'}}</span>
    </small>
    }
    @if(customerHeaderService.showEntityDataMetadataReadonly().ownedBy) {
    <small>
      <span> by </span>
      <span class="text-primary">{{customerHeaderService.showEntityDataMetadataReadonly().ownedBy}}</span>
    </small>
    }
    @if(customerHeaderService.showEntityDataMetadataReadonly().branchSetCode) {
    <small>
      <span> for </span>
      <span class="text-primary">{{customerHeaderService.showEntityDataMetadataReadonly().branchSetCode}}</span>
    </small>
    }
  </h2>
  <span class="toolbar-spacer"></span>
  @if (customerHeaderService.badge()) {
  <div
    class="flex lg:text-lg text-md lg:px-2 px-1 font-extrabold tracking-tight text-base/8 bg-primary uppercase text-white truncate rounded">
    {{customerHeaderService.badge()}}
  </div>
  }

  @if (customerHeaderService.showProductCategoryReadonly().show) {
  <div class="product-category-wrapper hidden lg:flex items-center lg:text-lg text-md lg:px-2 px-1"
    app-product-category-dropdown [idisabled]="customerHeaderService.showProductCategoryReadonly().disabled">
    <!-- <app-product-category-dropdown></app-product-category-dropdown> -->
  </div>
  }

  <!-- we are showing add button only the user who has CREATE_APPLICATION authority -->
  @if (customerHeaderService.showRouterLink()) {
  <button *hasAnyAuthority="['CREATE_APPLICATION', 'CREATE_MASTERS']" mat-mini-fab color="primary" class="mx-2"
    (click)="navigate()"><mat-icon>add</mat-icon>
  </button>
  }

</mat-toolbar>